import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import { sessionActions } from "../../store";
import { AppSettings } from "./../../config/app-settings.js";
import SweetAlert from "react-bootstrap-sweetalert";

const Login = () => {
    const context = useContext(AppSettings);
    const dispatch = useDispatch();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [sweetAlertError, setSweetAlertError] = useState(null);
    const [isFetchRequest, setIsFetchRequest] = useState(false);

    useEffect(() => {
        context.handleSetAppSidebarNone(true);
        context.handleSetAppHeaderNone(true);
        // returned function will be called on component unmount
        return () => {
            context.handleSetAppSidebarNone(false);
            context.handleSetAppHeaderNone(false);
        };
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsFetchRequest(true);
        try {
            const response = await fetch("/api/user/login", {
                method: "POST",
                body: new URLSearchParams(`email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`),
            });
            setIsFetchRequest(false);
            if (response.ok) {
                const user = await response.json();
                dispatch(sessionActions.updateUser(user));
                setRedirect(true);
            } else {
                const result = await response.json();
                if (Array.isArray(result.error)) setSweetAlertError(result.error[0].msg);
                else setSweetAlertError(result.error);
                throw Error(await response.text());
            }
        } catch (error) {
            setIsFetchRequest(false);
            setPassword("");
        }
    };

    if (isFetchRequest) {
        return (
            <div>
                <div id="loader" className="app-loader loading">
                    <span className="spinner"></span>
                </div>
            </div>
        );
    }

    if (redirect && !isFetchRequest) {
        return <Redirect to="/" />;
    }

    return (
        <React.Fragment>
            <div className="login login-v2 fw-bold">
                <div className="login-cover">
                    <div
                        className="login-cover-img"
                        style={{ backgroundImage: "url(/assets/img/login-bg/login-bg-14.jpg)" }}></div>
                    <div className="login-cover-bg"></div>
                </div>

                <div className="login-container">
                    <div className="login-header">
                        <div className="brand">
                            <div className="d-flex align-items-center">
                                <span className="logo"></span> <b>Mambo</b> Admin
                            </div>
                            <small>Sistema de administracion empresarial</small>
                        </div>
                        <div className="icon">
                            <i className="fa fa-lock"></i>
                        </div>
                    </div>

                    <div className="login-content">
                        <form onSubmit={handleSubmit}>
                            <div className="form-floating mb-20px">
                                <input
                                    type="text"
                                    className="form-control fs-13px h-45px border-0"
                                    placeholder="Email"
                                    id="emailAddress"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    error="true"
                                />
                                <label htmlFor="emailAddress" className="d-flex align-items-center text-gray-600 fs-13px">
                                    Email
                                </label>
                            </div>

                            <div className="form-floating mb-20px">
                                <input
                                    type="password"
                                    className="form-control fs-13px h-45px border-0"
                                    placeholder="Contraseña"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <label htmlFor="emailAddress" className="d-flex align-items-center text-gray-600 fs-13px">
                                    Contraseña
                                </label>
                            </div>

                            <div className="form-check mb-20px">
                                <input className="form-check-input border-0" type="checkbox" value="1" id="rememberMe" />
                                <label className="form-check-label fs-13px text-gray-500" htmlFor="rememberMe">
                                    Recordarme
                                </label>
                            </div>
                            <div className="mb-20px">
                                <button type="submit" className="btn btn-success d-block w-100 h-45px btn-lg">
                                    Entrar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {sweetAlertError && (
                <SweetAlert
                    danger
                    confirmBtnText="Volver a intentar"
                    confirmBtnBsStyle="danger"
                    title="Error"
                    onConfirm={() => setSweetAlertError(null)}>
                    {sweetAlertError}
                </SweetAlert>
            )}
        </React.Fragment>
    );
};

export default Login;
